<template>
    <div
        class="ml-5 md:ml-12 z-40 fixed transition-all"
        :class="
            editMode ? 'mt-20 md:mt-24 opacity-100' : 'mt-5 md:mt-10 opacity-0'
        "
    >
        <div class="tooltip tooltip-right" data-tip="Adauga Sectiune">
            <button
                class="btn btn-sm btn-circle btn-warning"
                @click="showPicker = !showPicker"
            >
                <font-awesome-icon icon="fa-solid fa-plus" />
            </button>
        </div>

        <!-- Section type picker -->
        <transition name="picker-fade">
            <div v-if="showPicker" class="as-picker">
                <div class="as-picker__title">Tip sectiune</div>
                <button class="as-picker__opt" @click="addTextSection">
                    <font-awesome-icon icon="fa-solid fa-align-left" class="as-picker__icon" />
                    <span>Text</span>
                </button>
                <button
                    class="as-picker__opt"
                    :class="{ 'as-picker__opt--disabled': hasFormSection }"
                    :disabled="hasFormSection"
                    @click="addFormSection"
                >
                    <font-awesome-icon icon="fa-solid fa-clipboard-list" class="as-picker__icon" />
                    <span>Formular RSVP</span>
                    <small v-if="hasFormSection" class="as-picker__hint">deja adaugat</small>
                </button>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        templateSections: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            showPicker: false,
        };
    },
    computed: {
        ...mapGetters(['isEditMode']),
        editMode() {
            return this.isEditMode;
        },
        hasFormSection() {
            if (!this.templateSections) return false;
            return Object.values(this.templateSections).some(
                (s) => s._sectionType && s._sectionType.value === 'form'
            );
        },
    },
    methods: {
        addTextSection() {
            this.showPicker = false;
            const nextSectionKey = this.generateRandomString(4);
            const newSection = {
                _sectionDisplay: `Section ${nextSectionKey}_custom`,
                _sectionType: {
                    _displayName: 'Section Type',
                    value: 'text',
                },
                order: 0,
                textBlocks: [
                    {
                        text: 'Titlu nou',
                        fontFamily: "'Dancing Script', cursive",
                        fontSize: '40',
                        textColor: '#000000',
                        marginTop: '10',
                        textShadow: false,
                        cssClass: '',
                    },
                    {
                        text: 'Descriere noua',
                        fontFamily: "'Dancing Script', cursive",
                        fontSize: '20',
                        textColor: '#000000',
                        marginTop: '5',
                        textShadow: false,
                        cssClass: '',
                    },
                ],
                backgroundColor: {
                    _config: {
                        _displayName: 'Background Color',
                        _inputType: 'color',
                    },
                    value: '#ffffff',
                },
                backgroundImage: {
                    _config: {
                        _displayName: 'Background Image',
                        _inputType: 'image',
                    },
                    value: '',
                },
                minHeight: {
                    _config: {
                        _displayName: 'Min Height',
                        _inputType: 'select',
                        _selectOptions: ['50vh', '100vh'],
                    },
                    _value: '100vh',
                },
                _CSSclass: {
                    _config: {
                        _displayName: 'CSS Class',
                        _inputType: 'text',
                    },
                    value: 'new-section',
                },
            };
            this.$emit('add-section', nextSectionKey, newSection);
        },
        addFormSection() {
            if (this.hasFormSection) return;
            this.showPicker = false;
            const nextSectionKey = this.generateRandomString(4);
            const newSection = {
                _sectionDisplay: 'RSVP Section',
                _sectionType: {
                    _displayName: 'Section Type',
                    value: 'form',
                },
                order: 99,
                title: {
                    text: {
                        _config: {
                            _displayName: 'Section Title',
                            _inputType: 'text',
                        },
                        value: 'Confirma prezenta',
                        textShadow: 'false',
                    },
                    fontFamily: {
                        _config: {
                            _displayName: 'Font',
                            _inputType: 'select',
                        },
                        _value: 'default',
                    },
                    fontSize: {
                        _config: {
                            _displayName: 'Text Size',
                            _inputType: 'range',
                            _min: '9',
                            _max: '300',
                        },
                        value: '60',
                    },
                    textColor: {
                        _config: {
                            _displayName: 'Text Color',
                            _inputType: 'color',
                        },
                        value: '#000000',
                    },
                    marginTop: {
                        _config: {
                            _displayName: 'Title Margin Top',
                            _inputType: 'range',
                            _min: '0',
                            _max: '70',
                        },
                        value: '15',
                    },
                    _CSSclass: {
                        _config: {
                            _displayName: 'CSS Class',
                            _inputType: 'text',
                        },
                        value: 'rsvp-title',
                    },
                },
                description: {
                    text: {
                        _config: {
                            _displayName: 'Section Description',
                            _inputType: 'text',
                        },
                        value: 'Te rugam sa completezi formularul de mai jos.',
                        textShadow: false,
                    },
                    fontFamily: {
                        _config: {
                            _displayName: 'Font',
                            _inputType: 'select',
                        },
                        _value: 'default',
                    },
                    fontSize: {
                        _config: {
                            _displayName: 'Description Text Size',
                            _inputType: 'range',
                            _min: '9',
                            _max: '300',
                        },
                        value: '40',
                    },
                    textColor: {
                        _config: {
                            _displayName: 'Text Color',
                            _inputType: 'color',
                        },
                        value: '#000000',
                    },
                    marginTop: {
                        _config: {
                            _displayName: 'Description Margin Top',
                            _inputType: 'range',
                            _min: '0',
                            _max: '70',
                        },
                        value: '10',
                    },
                    _CSSclass: {
                        _config: {
                            _displayName: 'CSS Class',
                            _inputType: 'text',
                        },
                        value: 'rsvp-description',
                    },
                },
                backgroundColor: {
                    _config: {
                        _displayName: 'Background Color',
                        _inputType: 'color',
                    },
                    value: '#ffffff',
                },
                backgroundImage: {
                    _config: {
                        _displayName: 'Background Image',
                        _inputType: 'image',
                    },
                    value: '',
                },
                minHeight: {
                    _config: {
                        _displayName: 'Minimum Height',
                        _inputType: 'select',
                        _selectOptions: ['50vh', '100vh'],
                    },
                    _value: '100vh',
                },
                _CSSclass: {
                    _config: {
                        _displayName: 'Section CSS Class',
                        _inputType: 'text',
                    },
                    value: 'section-rsvp',
                },
                fields: {
                    adultCount: true,
                    childrenCount: true,
                    foodMenu: false,
                    childrenMenu: false,
                    accomodation: false,
                    message: true,
                },
            };
            this.$emit('add-section', nextSectionKey, newSection);
        },
        generateRandomString(length) {
            let result = '';
            const characters =
                'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            for (let i = 0; i < length; i++) {
                result += characters.charAt(
                    Math.floor(Math.random() * charactersLength)
                );
            }
            return result;
        },
    },
};
</script>

<style scoped>
.as-picker {
    position: absolute;
    top: 40px;
    left: 0;
    background: #1e293b;
    border: 1px solid #334155;
    border-radius: 12px;
    padding: 10px;
    min-width: 190px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
    z-index: 50;
}
.as-picker__title {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #64748b;
    padding: 2px 8px 8px;
}
.as-picker__opt {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 8px 10px;
    border: none;
    border-radius: 8px;
    background: transparent;
    color: #e2e8f0;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.12s;
}
.as-picker__opt:hover { background: rgba(255,255,255,0.08); }
.as-picker__opt--disabled {
    opacity: 0.4;
    cursor: not-allowed;
}
.as-picker__opt--disabled:hover { background: transparent; }
.as-picker__icon { width: 16px; color: #94a3b8; }
.as-picker__hint {
    margin-left: auto;
    font-size: 10px;
    font-weight: 500;
    color: #64748b;
}

.picker-fade-enter-active,
.picker-fade-leave-active {
    transition: opacity 0.15s, transform 0.15s;
}
.picker-fade-enter-from,
.picker-fade-leave-to {
    opacity: 0;
    transform: translateY(-6px);
}
</style>
